import { HelmetData } from 'react-helmet-async'

export const helmet = new HelmetData({})
